import React from 'react';
import Router from './components/Router';
import Theme from './components/Theme';
import './i18n';

const App = () => {
	return (
		<Theme>
			<Router />
		</Theme>
	);
};

export default App;
